<template>
  <div>
    <div class="mt-1 pill__SearchInput InputGroupFocus !w-full mb-4">
      <input
        class="form-control !py-1 "
        type="text"
        :placeholder="$t('Search data storage')"
        v-model="bcFileStore.query"
      />
      <aw-icon 
        icon="search" 
        v-show="!showCloseIcon"
      />
      <button 
        v-show="showCloseIcon"
        @click.stop.prevent="eraseSearch()"
        class="SearchInput__CloseIcon"
      >
        <aw-icon icon="close"/>
      </button>
    </div>
    <div 
      v-if="!bcFileStore.loading"
      class="flex flex-col"
    >
      <div 
        class="grid grid-cols-3 sm:grid-cols-6 gap-2"
      >
        <file-preview 
          v-for="item in visibleList"
          :key="item.id"
          :item="item" 
        />
      </div>
      <div class="flex justify-end gap-4 mt-1">
        <button
          class="text-sm"
          :class="{'text-gray-200 pointer-events-none': previousNotAvailable}"
          @click.stop.prevent="prevPage()"
        >
          <aw-icon
            icon="chevron-left"
            class="w-5 h-5 mr-1"
          />
          {{ $t('Previous') }}
        </button>
        <button
          class="text-sm"
          :class="{'text-gray-200 pointer-events-none': nextNotAvailable}"
          @click.stop.prevent="nextPage()"
        >
          {{ $t('Next') }}
          <aw-icon
            icon="chevron-right"
            class="w-5 h-5 ml-1"
          />
        </button>
      </div>
    </div>
    <div
      v-if="bcFileStore.loading"
      class="flex items-center justify-center pointer-events-none select-none h-36"
    >
      <aw-icon 
        icon="loader" 
        class="h-24 w-24 text-bc-blue"
      />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcFileStore from '@/frontapp/store/bcFile'
import { computed, watch, ref } from 'vue'

export default {
  data () {
    return {
      limit: 6,
    }
  },
  setup () {
    const bcFileStore = useBcFileStore()
    bcFileStore.showModalSearch(true, 12)

    if (bcFileStore.list.length === 0) {
      bcFileStore.loadFiles()
    }

    const showCloseIcon = computed(() => {
      return bcFileStore.q && bcFileStore.q.length
    })

    const eraseSearch = () => {
      bcFileStore.query = ''
    }
    const page = ref(1)
    watch(() => bcFileStore.q, () => {
      bcFileStore.list = []
      bcFileStore.offset = 0
      page.value = 1
      bcFileStore.loadFiles()
    })

    return {
      page,
      eraseSearch,
      showCloseIcon
    }
  },
  computed: {
    ...mapStores(useBcFileStore),
    previousNotAvailable() {
      return this.page === 1
    },
    nextNotAvailable() {
      return this.bcFileStore.list && this.bcFileStore.list.length < this.page * this.limit
    },
    visibleList() {
      return this.bcFileStore.list.slice((this.page - 1) * this.limit, this.page * this.limit)
    }
  },
  methods: {
    prevPage() {
      if (this.previousNotAvailable) return
      
      this.page -= 1
    },
    nextPage() {
      if (this.nextNotAvailable) return
      
      this.page += 1
      if (this.bcFileStore.list && this.bcFileStore.list.length % 12 === 0) {
        this.bcFileStore.offset = (this.page - 1) * 12
        this.bcFileStore.loadFiles()
      }
    },
  }
}
</script>

<style lang="scss">
</style>
